import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../ui/Button/Button";
import { useTabPanels } from "../../../../ui/TabPanels/TabPanels";
import { SectionHeading } from "../SectionHeading";

type LeadSuccessViewProps = {
  allowPricing: boolean;
};

export const LeadSuccessView: FunctionComponent<LeadSuccessViewProps> = ({
  allowPricing,
}) => {
  const { next } = useTabPanels();
  const { t } = useTranslation();

  return (
    <>
      <SectionHeading translation="searchResults.leadSuccessHeading" />
      <p className="text-xs font-thin text-ink-2">
        {t("searchResults.dealerFormDescription")}
      </p>
      <Button
        aria-label="resetLeadForm"
        className="bg-input border border-edge flex h-10 mt-8 w-full"
        onClick={next}
      >
        {t(
          allowPricing
            ? "searchResults.backToQuote"
            : "searchResults.backToContact"
        )}
      </Button>
    </>
  );
};
